<template>
  <section class="section" style="margin-top: -40px;">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ລາຍການອອກຕະຫຼາດ
          </h2>
        </div>
      </div>
      <div class="columns" style=" margin-top: -40px;">
        <div class="column">
            ຍອດເງິນ: <span style="color:red; font-size: 24px; margin-left: 5px; margin-right: 5px;"> {{ accountBalance | formatNumberLocal }} </span> ກີບ
          
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 30">
        
        <b-tab-item label="ການອອກຕະຫຼາດ">
         
          <b-tabs v-model="activeSubTab">
        
            <b-tab-item label="ລາຍການ">
            
              <b-field>
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                    
                      <th class="has-text-centered " width="10%">
                        ວັນທີ 
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ລາຍລະອຽດ
                      </th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data) in purchaselist"
                      :key="data.REDATE"
                    >
                      <td class="has-text-centered">
                        {{ dateFormatter(data.REDATE)  }}
                        <br>
                        <span style="color: red">{{ data.COUNTPRODUCT | formatNumberLocal }}</span> ສິນຄ້າ
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                      <td class="has-text-centered">
                        <span v-if="data.STATUS ==2" style="color: red;">
                          ຢືນຢັນລາຍການແລ້ວ
                          <br>
                        </span>
                        <b-button
                        class="btn-group-margin"
                        type="is-info"
                        @click="purchaseProductList(data.REDATE, data.MARKETBATCHID, 2)"
                        >ລາຍລະອຽດ  
                      </b-button>
                          
                      </td>
                    
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </b-tab-item>
            <b-tab-item label="ລາຍລະອຽດ">
            
              <b-field label="">
                <div class="columns">
                  <div class="column">
                    <label slot="label">
                      ລາຍການສັ່ງຊື້: <span style="font-weight: bold;">{{ dateFormatter(selectedPurchaseDate) }}</span>
                    </label>
                    <br>
                    <label slot="label">
                    ລວມເງິນຊື້ສິນຄ້າ: <span style="font-weight: bold;">{{ selectedPurchaseDateAmount | formatNumberLocal }}</span>
                    </label>
                  </div>

                  <div class="column" style=" padding: 0; margin: 0; text-align: right;">
                    <b-button v-if="productRemainConfirm != 0"
                      class="btn-group-margin"
                      type="is-danger"
                      @click="confirmAllPurchaseMarket()"
                      >ຢືນຢັນຄວາມຖືກຕ້ອງ  
                    </b-button>
                  </div>
                </div>
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-left " width="50%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈຳນວນ
                    </th>
                    <th class="has-text-left " width="30%">
                      ລາຍລະອຽດ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productList"
                    :key="data.PRODUCTANDTYPE"
                  >
                    <td class="has-text-left">
                      {{index +1 }}. {{ data.PRODUCTNAME  }}<br> 
                      <img
                        class="image-area"
                        style="width: 100%; max-width: 100px; "
                        :src="getImgUrl('products/' + data.PHOTONAME)"
                        @click="showPopup(data.PHOTONAME)"
                        
                      />  
                    </td>
                    <td class="has-text-right" v-if="data.STATUS == 2 && parseFloat(data.MARKETQUANTITY) == 0 " style="background-color: red; color: white;">
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }}
                          <br> 
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>
                          
                    </td>
                    <td class="has-text-right" v-else-if=" (parseFloat(data.MARKETQUANTITY) > 0 || data.STATUS == 2 ) && parseFloat(data.QUANTITY) > parseFloat(data.MARKETQUANTITY) " style="background-color: yellow;">
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }}
                          <br> 
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>
                          
                    </td>
                    <td class="has-text-right" v-else>
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }}
                          <br>
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>
                    </td>
                    <td class="has-text-left">
                      <b-button
                        class="btn-group-margin"
                        type="is-info"
                        size="is-small"
                        @click="purchaseProductSubList(data.PURCHASEMARKETID, data.PRODUCTID, data.MARKETID, data.QUANTITY, data.MARKETQUANTITY, data.STATUS )"
                        >ລາຍລະອຽດ
                      </b-button>
                    </td>
                    
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th  class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      {{ _.sumBy(productList, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>
                    <th class="has-text-right">
                      
                    </th>                 
                  </tr>
                </tfoot> 
              </table>
              
            </b-tab-item>
            <b-tab-item label="ສິນຄ້າຍ່ອຍ">
              <div v-if="((selectedProductQuantity == selectedProductMarketQuantity) && selectedProductQuantity > 0) || isConfirmed ==1 ||  selectedProductMarketStatus  ==2" style="margin-bottom: 10px;">  
                <span style="color: red; ">ປ້ອນຄົບ ຫຼື ຢືນຢັນແລ້ວ </span> 
              </div>
              <div v-else>
                <span style="font-size: 16px; font-weight: bold;">ຈຳນວນທີ່ຕ້ອງການ: <span style="color: red;">{{ selectedProductQuantity}}</span> / <span style="color: red">{{selectedProductMarketQuantity }}</span></span> <br>    
                <span style="font-size: 16px; font-weight: bold;">ຈຳນວນທີ່ຊື້</span>  
                <b-field grouped>
                  <b-field> 
                    <b-input 
                      v-model.trim="selectedProductQuantityRemain"
                      type="number"  
                      min="0"
                      pattern="[0-9]+"
                      class="text-right-input"
                      placeholder="ຈຳນວນ"
                      style="width: 70px;text-align: right;"
                    >
                    </b-input>
                  
                  </b-field>
                
                  <b-field>
                    <b-input 
                      v-model.trim="productTotalPrice"
                      type="number"  
                      min="0"
                      pattern="[0-9]+"
                      class="text-right-input"
                      placeholder="ຈຳນວນເງິນ"
                      style="width: 130px;text-align: right;"
                    >
                    </b-input>
                  
                  </b-field>
                  <b-field>
                    <b-button style="margin-top: 0px;"
                      class="btn-group-margin"
                      type="is-primary"
                      @click="updatePurchaseMarketQuantity(  '','','', 2, '', '','', '','')"
                      >ບັນທຶກ
                    </b-button>
                  
                  </b-field>
                </b-field>
              </div>
                
              <span style="font-size: 16px; font-weight: bold;">ລາຍການສິນຄ້າ</span>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-left " width="85%">
                      ສິນຄ້າຍ່ອຍ
                    </th>
                    <th class="has-text-right " width="10%">
                      ຈຳນວນ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productSubList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td class="has-text-left">
                      <span style="font-weight: bold; font-size: 18px;">{{ data.PRODUCTNAME_SUB }}</span><br>
                      <span style="color: darkgrey;">{{ data.COMPANY }}</span>
                      
                    </td>
                    <td class="has-text-right">
                      {{ data.QUANTITY | formatNumberLocal }}
                    </td>
                  
                  </tr>
                </tbody>
              </table>
              <div style=" margin-top: 30px;">
                <span style="font-size: 16px; font-weight: bold;">ປະຫວັດການຊື້</span>  
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                    
                      <th class="has-text-centered " width="5%">
                        #
                      </th>
                      <th class="has-text-centered " width="30%">
                        ເວລາ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນເງິນ
                      </th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in productSubBuyHistory"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td class="has-text-centered">
                        {{ data.TXTIME }}
                        
                      </td>
                      <td class="has-text-right">
                        
                        <span v-if="data.NEED_TO_UPDATE ==0">{{ data.QUANTITY | formatNumberLocal }}</span>
                        <span v-else-if="data.NEED_TO_UPDATE ==1" style="text-align: right;">
                          <b-input
                              v-model.trim="data.QUANTITY"
                              type="number"  
                              min="0"
                              pattern="[0-9]+"
                              class="text-right-input"
                              placeholder="ຈຳນວນ"
                              style="width: 80px; margin-top: 5px; text-align: right;"
                            ></b-input>
                        </span>
                      </td>
                      <td class="has-text-right">
                        <span v-if="data.NEED_TO_UPDATE ==0">{{ data.TOTALPRICE | formatNumberLocal }}</span>
                        <span v-else-if="data.NEED_TO_UPDATE ==1" style="text-align: right;">
                          <b-input
                              v-model.trim="data.TOTALPRICE"
                              type="number"  
                              min="0"
                              pattern="[0-9]+"
                              class="text-right-input"
                              placeholder="ຈຳນວນເງິນ"
                              style="width: 100px; margin-top: 5px; text-align: right;"
                            ></b-input>
                        </span>
                        <br>
                        <b-button v-if="data.NEED_TO_UPDATE ==0 && data.ISCONFIRM==0"
                          class="btn-group-margin"
                          type="is-primary"
                          @click="updatePurchaseMarketQuantityForm(index)"
                          >ແກ້ໄຂ
                        </b-button>
                        <b-button v-else-if="data.NEED_TO_UPDATE ==1"
                          class="btn-group-margin"
                          type="is-primary"
                          @click="updatePurchaseMarketQuantity(data.PURCHASEMARKETID, data.QUANTITY,data.TOTALPRICE, 1, data.PRODUCTID, data.MARKETBATCHID, data.REDATE, data.MARKETID, data.ID)"
                          >ແກ້ໄຂ
                        </b-button>

                        <b-button v-if="data.NEED_TO_UPDATE ==0 && data.ISCONFIRM==0"
                          class="btn-group-margin"
                          type="is-danger" 
                          @click="cancelPurchaseMarketHistory(data.ID,data.PURCHASEMARKETID,data.PRODUCTID)"
                          >ຍົກເລີກ
                        </b-button>
                      </td>
                    
                    </tr>
                  </tbody>
                  <tfoot>
                  <tr v-if="selectedProductQuantity > selectedProductMarketQuantity" style="background-color: yellow;">
                    <th colspan="2" class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      <span >
                        {{ m_quantity  | formatNumberLocal}}/ {{ _.sumBy(productSubBuyHistory, i => parseFloat(i["QUANTITY"])) | formatNumberLocal }} 
                      </span>
                       
                      
                     
                    </th> 
                    <th  class="has-text-right">
                      {{ _.sumBy(productSubBuyHistory, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>            
                  </tr>

                  <tr v-else>
                    <th colspan="2" class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      <span >
                        {{ m_quantity  | formatNumberLocal}}/ {{ _.sumBy(productSubBuyHistory, i => parseFloat(i["QUANTITY"])) | formatNumberLocal }} 
                      </span>
                       
                      
                     
                    </th> 
                    <th  class="has-text-right">
                      {{ _.sumBy(productSubBuyHistory, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>            
                  </tr>
                </tfoot>
                </table>
              </div>
              
                
            </b-tab-item>
            
            
          </b-tabs>
        </b-tab-item>
        <b-tab-item label="ການອັບເດດລາຄາ">
         
          <b-tabs v-model="activeSubTab">
        
            <b-tab-item label="ຍົກ(16-18)">
              <div class="columns">
                <div class="column">
                 
                </div>

                <div class="column" style=" padding: 0; margin: 0; text-align: right;">
            
                  <!-- <b-button
                    class="btn-group-margin"
                    type="is-primary"
                    size="is-small"
                    @click="savePrice(1)"
                    >ບັນທຶກລາຄາ  
                  </b-button> -->
                </div>
              </div>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-left " width="40%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="60%">
                      ລາຄາ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productPromotionList"
                    :key="data.ID"
                  >
                    <td class="has-text-left">
                      {{ data.NAME }}<br>
                      <b-field style="text-align: left;" v-if="data.B_UNITPRICE1_ORIGINAL != null || data.B_UNITPRICE2_ORIGINAL != null">
                        <b-button v-if="data.B_UNITPRICE_NEED_UPDATE ==0"
                          class="btn-group-margin"
                          type="is-danger"
                          size="is-small"
                          @click="updatePriceForm(index)"
                          > ແກ້ໄຂລາຄາ
                        </b-button>
                        <b-button v-else
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="updatePrice(data)"
                          > ແກ້ໄຂລາຄາ
                        </b-button>
                        

                      </b-field>

                      <b-field v-else>
                        <b-button
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="savePrice(1)"
                          >ບັນທຶກລາຄາ  
                        </b-button>
                      </b-field>

                      

                    </td>
                    <td class="has-text-centered"  >
                      <b-field v-if="data.B_UNITPRICE1_ORIGINAL == null || data.B_UNITPRICE_NEED_UPDATE ==1" >
                        <b-input
                          v-model.trim="data.B_UNITPRICE1"
                          type="number"  
                          min="0"
                          pattern="[0-9]+"
                          class="text-right-input"
                          placeholder="ລາຄາຖືກສຸດ"
                          style="width: 100%;"
                        >
                        </b-input>
                      </b-field>
                      <b-field v-else style="text-align: right;">
                        {{ data.B_UNITPRICE1 | formatNumberLocal }}
                      </b-field>
                      
                      <b-field v-if="data.B_UNITPRICE2_ORIGINAL == null || data.B_UNITPRICE_NEED_UPDATE ==1" >
                        <b-input
                          v-model.trim="data.B_UNITPRICE2"
                          type="number"  
                          min="0"
                          pattern="[0-9]+"
                          class="text-right-input"
                          placeholder="ລາຄາແພງສຸດ"
                          style="width: 100%; margin-top: 5px;"
                        >
                        </b-input>
                      </b-field>
                      <b-field v-else style="text-align: right;">
                        {{ data.B_UNITPRICE2 | formatNumberLocal }}
                      </b-field>
                      
                    </td>
                  
                  </tr>
                </tbody>
              </table>
             
            </b-tab-item>
            <b-tab-item label="ຍົກ(1-3)">
            
              
              
            </b-tab-item>
            <b-tab-item label="ຍ່ອຍ(4-6)">
              
              
                
            </b-tab-item>
            
            
          </b-tabs>
           
        </b-tab-item>
        
        
      </b-tabs>
    </div>

    <div v-if="isPopupVisible" class="popup" @click="hidePopup">
      <span class="close" @click.stop="hidePopup">&times;</span>
      <img :src="popupImgSrc" class="popup-content">
    </div>
  
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import { BFormSelect } from 'bootstrap-vue'
// import Multiselect from "vue-multiselect";
import moment from "moment";

// import PrintSummaryTable from "@/components/PrintSummaryTable.vue";

export default {
  // components: {BFormSelect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,

      activeTab: 0,
      activeSubTab: 0,
      activeSub2Tab: 0,


      activeSub2TabList: 0,
      purchaselist: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "http://64.176.85.31/manager/api/uploads/"
          // : "http://localhost/agrilao-manager/api/uploads/",
          : "http://64.176.85.31/manager/api/uploads/",

      selectedPurchaseDate: null,
      selectedPurchaseDateAmount: null,
      selectedPurchaseMarketBatchid: null,
      selectedMarketID: null,
      selectedPurchaseMarketID: null,
      selectedProductID : null,
      productList: [],
      productRemainConfirm: [],
      productSubList: [],
      productSubBuyHistory: [],
      productPromotionList: [],
      productAllList: [],
      isConfirmed: 0,

      isPopupVisible: false,
      popupImgSrc: '',
      accountBalance: 0,

      productQuantity: 0,
      productTotalPrice: 0,
      m_quantity: 0,
      selectedProductQuantity: 0,
      selectedProductMarketQuantity: 0,
      selectedProductQuantityRemain: 0,
      selectedProductMarketStatus: null,
      
    };
  },
  methods: {
    
    cancelPurchaseMarketHistory(HISTORYID,PURCHASEMARKETID, PRODUCTID){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            historyid: HISTORYID,
            purchasemarketid: PURCHASEMARKETID,
            username: this.username,
          };
            
          RestAPI.cancelPurchaseMarketHistory(params)
            .then(() => {
              this.purchaseProductSubList(PURCHASEMARKETID, PRODUCTID, this.selectedMarketID, this.selectedProductQuantity, this.selectedProductMarketQuantity, this.selectedProductMarketStatus);
              this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 1);
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },


    getPurchaserAccountBalance() {
    RestAPI.getPurchaserAccountBalance( this.username)
      .then((res) => {
        this.accountBalance = res.data;
        console.log("accountBalance: " + JSON.stringify(res.data))
        // console.log("res: " + JSON.stringify(res.data))
      })
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    showPopup(PHOTONAME) {
      this.popupImgSrc = this.getImgUrl('products/' + PHOTONAME);
      this.isPopupVisible = true;
      console.log("PHOTONAME: "+ PHOTONAME)
    },
    hidePopup() {
      this.isPopupVisible = false;
    },
    updatePrice(data){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            productPromotionList: data,
            username: this.username,
          };
          console.log("params: " +JSON.stringify(params))
            
          RestAPI.updatePrice(params)
            .then(() => {
              this.productUpdatePriceList();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },


    updatePriceForm(index){
      // console.log("index: " + index)
      // console.log("this.productPromotionList before: " +JSON.stringify(this.productPromotionList))
      this.productPromotionList[index].B_UNITPRICE_NEED_UPDATE = 1;
      // console.log("this.productPromotionList after: " +JSON.stringify(this.productPromotionList))
    },
    clearPrice(ID){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF2B56",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            productpriceid: ID,
            username: this.username,
          };
            
          RestAPI.clearPrice(params)
            .then(() => {
              this.productUpdatePriceList();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    savePrice(type){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var params;
          if(type==1){
              params = {
                productPrice: this.productPromotionList,
                username: this.username,
              };
          }else{
              params = {
                productPrice: this.productPromotionList,
                username: this.username,
              };
          }
          
          RestAPI.savePrice(params)
            .then(() => {
              // this.purchaseProductList(this.selectedPurchaseDate);
              this.productUpdatePriceList();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    productUpdatePriceList() {

      RestAPI.productUpdatePriceList( this.username)
        .then((res) => {
          this.productPromotionList = res.data.promotionlist;
          this.productAllList = res.data.alllist;
          // console.log("res.data: " + JSON.stringify(res.data))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    confirmAllPurchaseMarket(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var params = {
            productlist: this.productList,
            username: this.username,
          };
          RestAPI.confirmAllPurchaseMarket(params)
            .then(() => {
              this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 3);
              this.getPurchaserAccountBalance();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    updatePurchaseMarketQuantityForm(index){  
      this.productSubBuyHistory[index].NEED_TO_UPDATE = 1;
      // console.log("index: " +index)
      // console.log("this.productList[index]: " +this.productList[index])
    },

    updatePurchaseMarketQuantity(PURCHASEMARKETID = null, QUANTITY= null, TOTALPRICE= null, TYPE, PRODUCTID = null,MARKETBATCHID = null, REDATE = null, MARKETID= null, HISTORYID= null){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
         

          var params;

          if(TYPE == 2){
            if (this.selectedProductQuantityRemain === null || this.selectedProductQuantityRemain <= 0 || this.productTotalPrice === null || this.productTotalPrice <= 0) {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ+", "", "error");
              return false;
            }

            params = {
              type: TYPE,
              purchasemarketid: this.selectedPurchaseMarketID,
              quantity: this.selectedProductQuantityRemain,
              totalprice: this.productTotalPrice,
              productid: this.selectedProductID,
              marketbatchid: this.selectedPurchaseMarketBatchid,
              redate: this.selectedPurchaseDate,
              marketid: this.selectedMarketID,
              username: this.username,
            };
          }else{
            if (QUANTITY === null || QUANTITY <= 0 || TOTALPRICE === null || TOTALPRICE <= 0) {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ-", "", "error");
              return false;
            }
            params = {
              type: TYPE,
              purchasemarketid: PURCHASEMARKETID,
              quantity: QUANTITY,
              totalprice: TOTALPRICE,
              productid: PRODUCTID,
              marketbatchid: MARKETBATCHID,
              redate: REDATE,
              marketid: MARKETID,
              historyid: HISTORYID,
              username: this.username,
            };

            this.selectedPurchaseMarketID = PURCHASEMARKETID;
            this.selectedProductID = PRODUCTID;

          }

          // console.log("PURCHASEMARKETID: " + PURCHASEMARKETID)
          // console.log("PRODUCTID: " + PRODUCTID)
          // console.log("params: " +JSON.stringify(params))
          
          RestAPI.updatePurchaseMarketQuantity(params)
            .then(() => {
              this.productQuantity = 0;
              this.productTotalPrice = 0;
              this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 1); // 1 ເພື່ອບໍ່ໃຫ້ແລ່ນໄປຫນ້າກ່ອນຫນ້າ
              this.purchaseProductSubList(this.selectedPurchaseMarketID,  this.selectedProductID,this.selectedMarketID, this.selectedProductQuantity, this.selectedProductMarketQuantity, this.selectedProductMarketStatus );
              
              this.selectedProductQuantity;
              this.selectedProductMarketQuantity;
              this.selectedProductQuantityRemain;

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              // console.log("PURCHASEMARKETID: " + PURCHASEMARKETID)
              // console.log("PRODUCTID: " + PRODUCTID)
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    purchaseProductSubList(PURCHASEMARKETID,  PRODUCTID, MARKETID, QUANTITY, MARKETQUANTITY, STATUS) {
      
      this.selectedPurchaseMarketID = PURCHASEMARKETID;
      this.selectedProductID = PRODUCTID;

      this.selectedMarketID = MARKETID;
      // this.selectedProductQuantity= QUANTITY;
      // this.selectedProductMarketQuantity = MARKETQUANTITY;
      this.selectedProductMarketStatus = STATUS;

      // this.selectedProductQuantityRemain = QUANTITY-MARKETQUANTITY;
      
      RestAPI.purchaseProductSubList(PURCHASEMARKETID, PRODUCTID, this.username)
        .then((res) => {
          this.productSubList = res.data.productsubList;
          this.productSubBuyHistory = res.data.history;
          this.isConfirmed = res.data && res.data.history && res.data.history.length > 0 ? res.data.history[0].ISCONFIRM : 0;
          this.m_quantity = res.data && res.data.history && res.data.history.length > 0 ? res.data.history[0].M_QUANTITY : 0;

          
        
          this.selectedProductQuantity= res.data.marketdata.QUANTITY;
          this.selectedProductMarketQuantity = res.data.marketdata.MARKETQUANTITY;
          this.selectedProductQuantityRemain = this.selectedProductQuantity - this.selectedProductMarketQuantity;
          this.selectedPurchaseDateAmount = res.data.marketdata.TOTALPRICE;


          this.activeSubTab = 2;
          console.log("res.data: " + JSON.stringify(res.data))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    purchaseProductList(date, batchid, TYPE){
      this.selectedPurchaseDate = date
      this.selectedPurchaseMarketBatchid = batchid;
      if(TYPE == 1){
        this.activeSubTab = 2;
      }else{
        this.activeSubTab = 1;
      }
      
      // console.log("purchaseProductList TYPE: "+TYPE)

      RestAPI.getMarketPurchaseProductList(this.username, date, this.selectedPurchaseMarketBatchid)
        .then((res) => {
          this.productList = res.data.list;
          this.productRemainConfirm = res.data.remain;
          this.selectedPurchaseDateAmount = res.data.marketdata.TOTALPRICE;
          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getMarketPurchaseList() {
      RestAPI.getMarketPurchaseList(this.username)
        .then((res) => {
          console.log("res.data: " + JSON.stringify(res.data));
          this.purchaselist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },

    
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getMarketPurchaseList();
    this.productUpdatePriceList();
    this.getPurchaserAccountBalance();  

  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    isSummaryOnFirstPage() {
      // Adjust this logic based on the number of rows and your page layout
      const numRowsPerPage = 20; // Change this based on your requirement
      return this.quotationdetaillist.length <= numRowsPerPage;
    },

 

    

    // isLastPage() {
    //   return this.currentPage === this.totalPages;
    // },

    // isFirstPage() {
    //   return this.currentPage === 1;
    // },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

/* Style for the close button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from { -webkit-transform: scale(0); }
  to { -webkit-transform: scale(1); }
}

@keyframes zoom {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

.text-right-input input {
  text-align: right;
}

.custom-align {
    text-align: right;
}
.asterisk {
  color: red;
}

.set-border {
  border: 1px solid #ddd;
}

/* .summary-footer {
  page-break-before: always;
} */

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
